import { Box, Button, Card, CardContent, CardMedia, Typography } from "@mui/material";
import ScheduleDialog from "./shedule_order";
import { useState } from "react";
import { styled, alpha } from "@mui/material/styles";

const ORANGE = "#f97316";
const ORANGE_HOVER = "#ea580c";
const BLACK = "#0b0f14";
const BLACK_ELEV = "#111827";
const CARD_RADIUS = 16;

const StyledCard = styled(Card)(({ theme }) => ({
  // removed fixed height so internal content (including button) is not clipped
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: alpha('#fff', 0.06),
  backdropFilter: 'blur(10px)',
  border: `1px solid ${alpha('#fff', 0.12)}`,
  borderRadius: CARD_RADIUS,
  paddingBottom: theme.spacing(2), // space for button
  overflow: 'hidden', // clip children so media cannot overflow the rounded corners
  transition: 'all .35s cubic-bezier(.4,0,.2,1)',
  '&:hover': {
    transform: 'translateY(-6px)',
    borderColor: alpha(ORANGE, 0.45),
    boxShadow: `0 10px 28px -6px ${alpha(ORANGE, .25)}, 0 4px 14px -4px rgba(0,0,0,.35)`
  }
}));

const ActionButton = styled(Button)(({  }) => ({
  backgroundColor: ORANGE,
  color: '#fff',
  fontWeight: 600,
  textTransform: 'none',
  padding: '10px 20px',
  fontSize: '.95rem',
  borderRadius: 10,
  width: '100%',
  boxShadow: `0 6px 20px -6px ${alpha(ORANGE, .55)}`,
  position: 'relative',
  '&:hover': {
    backgroundColor: ORANGE_HOVER,
    boxShadow: `0 8px 26px -6px ${alpha(ORANGE, .6)}`,
    transform: 'translateY(-2px)'
  },
  '&:active': {
    transform: 'translateY(0)',
    boxShadow: `0 4px 14px -4px ${alpha(ORANGE, .45)}`
  }
}));

function CreateDisplayCards() {
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const cards = [
    {
      img: 'free_home_delivary.webp',
      alt: 'Free Home Delivery',
      title: 'Free Home Delivery',
      desc: 'Fast, reliable home delivery for all your laundry and dry cleaning needs'
    },
    {
      img: 'express_dry_clean.png',
      alt: 'Express Dry Cleaning',
      title: 'Express Dry Cleaning',
      desc: 'Enjoy express laundry delivery in as little as 4 hours'
    },
    {
      img: 'By_Weight.png',
      alt: 'Same Day Delivery',
      title: 'Same Day Delivery',
      desc: 'Get your clothes cleaned and delivered within 24 Hrs'
    }
  ];

  return (
    <Box
      sx={{
        width: '100%',
        background: `linear-gradient(180deg, ${BLACK} 0%, ${BLACK_ELEV} 100%)`,
        borderBottom: `1px solid ${alpha('#fff', 0.08)}`,
        py: { xs: 6, md: 8 },
        px: { xs: 2, sm: 4, md: 6 }
      }}
    >
      {/* Section Title */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography 
          variant="h3" 
          sx={{
            fontSize: { xs: '2rem', sm: '2.5rem' },
            fontWeight: 700,
            background: `linear-gradient(90deg, ${ORANGE} 0%, #ffb774 60%, #ffffff 100%)`,
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            mb: 2
          }}
        >
          Our Services
        </Typography>
        <Typography 
          sx={{ 
            color: alpha('#fff', 0.75),
            maxWidth: 600,
            mx: 'auto'
          }}
        >
          Choose from our range of premium laundry services designed to meet your needs
        </Typography>
      </Box>

      {/* Cards Container */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(3, 1fr)'
          },
          gap: 4,
          maxWidth: 1200,
          mx: 'auto'
        }}
      >
        {cards.map(c => (
          <StyledCard key={c.title}>
            <CardMedia
              component="img"
              image={c.img}
              alt={c.alt}
              loading="lazy"
              sx={{
                height: { xs: 190, md: 210 },
                width: '100%',
                display: 'block',
                objectFit: 'cover',
                // align media corners with the card
                borderTopLeftRadius: CARD_RADIUS,
                borderTopRightRadius: CARD_RADIUS
              }}
            />
            <CardContent sx={{ textAlign: 'center', pt: 2, pb: 1 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: '#fff',
                  mb: 1.25,
                  fontSize: '1.32rem',
                  letterSpacing: '-0.01em'
                }}
              >
                {c.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: alpha('#fff', 0.85),
                  fontSize: '.95rem',
                  lineHeight: 1.55
                }}
              >
                {c.desc}
              </Typography>
            </CardContent>
            <Box sx={{ px: 2, mt: 'auto' }}>
              <ActionButton onClick={handleOpenDialog}>
                Schedule Now
              </ActionButton>
            </Box>
          </StyledCard>
        ))}
      </Box>

      <ScheduleDialog open={openDialog} handleClose={handleCloseDialog} />
    </Box>
  );
}

export default CreateDisplayCards;
